
import { CrudService } from "../core/services/crudService";
import { Settings, TenantSettings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { Format } from "../core/helpers/formatHelper";
import InputText from "../components/form/inputText.vue";
import CreditCardForm from "../components/form/creditCardForm.vue";
import BookingSummary from "../components/bookingSummary/bookingSummary-v2.vue";
import Popup from "../components/popup/popup.vue";
import Checkbox from "../components/form/checkBox.vue";
import TriggerAnchor from "../components/triggerAnchor/triggerAnchor.vue";
import LookUp from "../components/form/lookUp.vue";
import { BookingPaymentType, BookingTeam } from "../core/constants";
import store from "@shared/core/store";
import { PriceDescriptor } from "../core/types/PriceDescriptor";
import CheckoutBookingPaymentTypes from "./checkoutBookingPaymentTypes.vue";
import AddPlayerPopup from "./addPlayerPopup.vue";
import Navigation from "@shared/components/navigation/navigation.vue";

@Component({
  components: {
    InputText,
    Popup,
    Checkbox,
    CreditCardForm,
    TriggerAnchor,
    LookUp,
    BookingSummary,
    CheckoutBookingPaymentTypes,
    AddPlayerPopup,
    Navigation,
  },
})
export default class CheckoutBookingPage extends Vue {
  settings: TenantSettings = {};
  error: string = "";
  data: any = null;
  transport: any = null;
  errors: any = {};
  paymentType: BookingPaymentType = BookingPaymentType.Full;
  booking: any = null;
  blocks: any = null;
  addPlayerPopup: boolean = false;
  players: any[] = [];
  owner: any = null;
  team1Selected: boolean = true;
  team2Selected: boolean = false;

  allowSharedPayment: boolean = false;
  allowFullPayment: boolean = true;
  allowPendingPayment: boolean = false;
  BookingPaymentType = BookingPaymentType;

  bookingPrice: number = 0;
  isMatch: boolean = false;

  sharedPaymentWithRetention: boolean = true;

  async created() {
    const sid = LocalStorage.getWithTimeout("cc");
    if (Format.IsNull(sid)) {
      this.$router.push("bookingtypes");
      return;
    }
    this.owner = JSON.parse(sid);

    const query = this.$route.query.pl;
    if (Format.IsNull(query)) {
      this.$router.push("bookingtypes");
      return;
    }

    let strQuery = "";
    try {
      strQuery = atob(query.toString());
    } catch (error) {
      this.$router.push("bookingtypes");
      return;
    }

    try {
      const data = JSON.parse(strQuery);
      this.booking = data.booking;

      const price = this.booking!.price;
      this.bookingPrice = price.amount;

      this.booking!.resources = data.booking.resourceName;
      this.blocks = data.blocks;
      this.players.push({
        name: this.owner.name,
        customerId: this.owner.id,
        logo: this.owner.logo,
        team: BookingTeam.NotSet,
        price: this.bookingPrice / this.booking!.maxParticipants,
      });
      this.isMatch = data.isMatch;
    } catch (error) {
      this.$router.push("bookingtypes");
      return;
    }
  }

  mounted() {
    window.scrollTo(0, 0);
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      console.log(
        "img2",
        store.state.settings.Uploads + "/" + store.state.settings.Mainlogo
      );

      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }

  getTeam(team: BookingTeam) {
    return team === BookingTeam.Team1
      ? this.$t("Team") + " " + 1
      : this.$t("Team") + " " + 2;
  }

  async addPlayer(customer: any) {
    this.addPlayerPopup = false;
    if (this.players.length === this.booking.maxParticipants) {
      this.error = this.$t("Max players reached").toString();
      this.$store.commit("openGlobalError", this.error);
      return;
    }

    if (this.players.length === 0) {
      this.players.push({
        name: this.owner.name,
        customerId: this.owner.id,
        logo: this.owner.logo,
        team: BookingTeam.NotSet,
        price: this.bookingPrice / this.booking.maxParticipants,
      });
    }

    const found = this.players.find((y) => y.customerId === customer.id);
    if (Format.IsNull(found)) {
      this.players.push({
        name: customer.name,
        customerId: customer.id,
        logo: customer.logo,
        team: BookingTeam.NotSet, // this.team1Selected ? BookingTeam.Team1 : BookingTeam.Team2,
        price: (await this.loadPrice(customer.id)).amount,
      });
      return;
    }
    found.team = BookingTeam.NotSet; //this.team1Selected ? BookingTeam.Team1 : BookingTeam.Team2;
  }

  removePlayer(player) {
    if (player.customerId === this.owner.id) {
      return;
    }
    this.players = this.players.filter(
      (y) => y.customerId !== player.customerId
    );
  }

  async loadPrice(customerId: number): Promise<PriceDescriptor> {
    const url = `${Settings.HostName}/api/publicbookings/loadprice`;

    const res = await new CrudService().httpPost(url, {
      startDate: this.booking.date,
      bookingTypeId: this.booking.bookingTypeId,
      duration: this.booking.duration,
      customerId: customerId,
      resourceId: this.blocks.find((y) => y.noOnline === false).resourceId,
    });

    if (Format.IsNull(res)) {
      this.$store.commit("openGlobalError", this.$t("crash"));
      return { amount: 0, isSpecialPrice: false };
    }

    if (res.ok === false) {
      this.error = res.errorMsg;
      this.$store.commit("openGlobalError", this.error);
      return { amount: 0, isSpecialPrice: false };
    }

    if(this.pricesWithTaxes) {
      return {
        amount: res.price.price / this.booking.maxParticipants,
        isSpecialPrice: res.price.isSpecialPrice,
      };
    }
    
    return {
      amount: res.price.netPrice / this.booking.maxParticipants,
      isSpecialPrice: res.price.isSpecialPrice,
    };
  }

  get pricesWithTaxes() {
    return this.$store.state.settings.PriceWithTaxes;
  }
}
